<template>
  <div
    class="chat-comment"
    :data-qa="`comment-${item.questionId}`">
    <div
      class="chat-comment-org"
      data-qa="chat-comment-org-14-0">
      <span
        class="chat-comment-org-name"
        data-qa="comments-org-name">{{ item.question.contact.userName }}</span>
      <span
        class="chat-comment-org-date"
        data-qa="comments-org-date">{{ $d(new Date(item.question.sentTime), 'longDate') }}</span>
    </div>
    <div
      class="chat-comment-message"
      data-qa="comments-message"
      @mouseleave="hover = false"
      @mouseover="hover = true">
      <sBadge
        class="width-100 chat-comment-title"
        color="red"
        :content="!item.answer"
        data-qa="comment-item-badge"
        dot
        offset-x="0"
        offset-y="0"
        overlap
        :value="!item.answer">
        {{ item.questionTitle }}
      </sBadge>
      <div>{{ item.question.message }}</div>
      <div
        v-if="!item.answer"
        class="chat-comment-button open">
        <sButton
          data-qa="comment-card-button"
          small
          type="text"
          @click="$emit('answer', {questionId: item.questionId, organizationTitle: item.organizationTitle, question: item.question.message})">
          {{ $t('Common.Answer') }}
        </sButton>
      </div>
    </div>
    <div
      v-if="item.answer && item.answer.message"
      class="chat-answer"
      data-qa="comments-14-answer-0">
      <div class="chat-answer-user">
        <span
          class="chat-answer-user-name"
          data-qa="comments-answer-name">{{ item.answer && item.answer.contact && item.answer.contact.userName ? item.answer.contact.userName : '-' }}</span>
        <span
          class="chat-answer-user-date"
          data-qa="comments-answer-date">{{ $d(new Date(item.answer.sentTime), 'longDate') }}</span>
      </div>
      <div
        class="chat-answer-message"
        data-qa="comments-message">
        {{ item.answer.message }}
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Чат вопросов к организатору
 */
export default {
  name: 'commentItem',
  data() {
    return {
      hover: false,
    }
  },
  props: {
    item: {
      type: Object,
      require: true
    },
  },
}
</script>
<style lang="scss" scoped>
.chat-comment {
  margin-top: 10px;
  &:first-child {
    margin-top: 0px;
  }
  &-org {
    display: flex;
    justify-content: flex-start;
    &-name {
      font-size: 14px;
      line-height: 18px;
    }
    &-date {
      margin-left: 10px;
      font-size: 12px;
      line-height: 16px;
      opacity: 0.5;
    }
  }
  &-message {
    white-space: pre-line;
    padding: 20px;
    margin-top: 5px;
    background: var(--green_chosen_light);
    transition: all 5s ease-out;
    border-radius: 0 25px 25px 25px;
  }
  &-title {
    font-size: 12px;
  }
  &-button {
    transition: all 0.25s ease-out;
    text-align: right;
    max-height: 1px;
    overflow: hidden;
  }
  &-button.open {
    max-height: 30px;
  }
}

.chat-answer {
    margin-top: 10px;
  &-user {
    display: flex;
    justify-content: flex-end;
  }
  &-user {
    &-name {
      font-size: 14px;
      line-height: 18px;
    }
    &-date {
      margin-left: 10px;
      font-size: 12px;
      line-height: 16px;
      opacity: 0.5;
    }
  }
  &-message {
    white-space: pre-line;
    background: var(--color-main-green);
    padding: 20px;
    margin-top: 6px;
    border-radius: 25px 0 25px 25px;
  }
}
</style>
